module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_agder_neg.27d781c4.pdf";